import { LoginWrapperStyled } from "../modules/Auth/components/styled/LoginStyled.js";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

function PageError({headerText = 'Page not found', code = '404', error = null}) {
    return <LoginWrapperStyled>
        <div style={{margin: '40px'}}>
            <h1>{headerText}</h1>
            <h3>{code}</h3>
            <p>Please return <a href="/">here</a></p>
        </div>
    </LoginWrapperStyled>
}

export default PageError;
